import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 14 14" fill="none" {...props}>
		<path d="M0.625 5.29167C0.625 5.29167 1.96165 3.47048 3.04756 2.38383C4.13346 1.29718 5.63407 0.625 7.29167 0.625C10.6054 0.625 13.2917 3.31129 13.2917 6.625C13.2917 9.93871 10.6054 12.625 7.29167 12.625C4.55627 12.625 2.24841 10.7945 1.52618 8.29167M4.625 5.29167H0.625V1.29167" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);